export const BRANCHES = [
    {
        value: 'Choose',
        label: 'Choose',
    },
    {
        value: 'C S',
        label: 'CSE',
    },
    {
        value: 'EC',
        label: 'ECE',
    },
    {
        value: 'EE',
        label: 'EE',
    },
    {
        value: 'CE',
        label: 'CE',
    },
    {
        value: 'ME',
        label: 'ME',
    },
    {
        value: 'BT',
        label: 'BT',
    },
]

export const EXCELFILES = [
    'data/B. TECH. I SEM DEC 18.xlsx',
    'data/B. TECH. II SEM JUNE 2019.xlsx',
    'data/B. TECH. III SEM DECEMBER 2019.xlsx',
    'data/B. TECH. IV SEM DECEMBER 2020.xlsx',
    'data/B. TECH. V SEM DECEMBER 2020 (COVID19 ).xlsx',
    'data/B. TECH. VI SEM JUNE 2021 (COVID 19 ).xlsx',
    'data/B. TECH. VII SEM DECEMBER 2021 (ON LINE ).xlsx',
    'data/B. TECH. VIII SEM JUNE 2022.xlsx',
]
